import { EnvironmentConfig } from "@me8eon/config";

export const featureFlagIndicesData = {
    "myhr": {
        "E.ON My HR": ["semantic-myhr-confluence-prod"],
    },
    "snowdev": {
        "E.ON IT Knowledge Base": ["semantic-kb-servicenow-dev2", "questionator-office-buddy-itsm-dev"],
    },
    "snowprod": {
        "E.ON IT Knowledge Base": ["semantic-kb-servicenow-prod2", "questionator-office-buddy-itsm-prod"],
    },
    "hrPolicies": {
        "HR Policies": [EnvironmentConfig.semanticHrIndex],
    },
    "compass": {
        "Compass": [EnvironmentConfig.semanticCompassIndex],
    },
    "betaUserFlag": {
        "Confluence": ["semantic-confluence-prod"],
        "E.ON SharePoint": ["ai-sharepoint-dso-dppublic-dev","ai-sharepoint-dso-dp-entwicklung", "ai-sharepoint-dso-dp-betrieb","ai-sharepoint-test-team-dso-dp"],
    }
} as const;

export const personalizedSearchData = {
    "E.DIS Netz GmbH": {
        "E.DIS Confluence": ["semantic-edis-confluence-prod"],
    },
    default: {},
} as const;

export const defaultSearchData = {
    "E.ON Knowledge Base": [EnvironmentConfig.semanticOfficeBuddyIndex, "semantic-meeondata-azureblob-prod"],
    "E.ON My IT order": ["questionator-order-it-api-prod"],
    // "E.ON IT Knowledge Base": [EnvironmentConfig.semanticKbServiceNowIndex as "semantic-kb-servicenow-dev2" | "semantic-kb-servicenow-prod2"],
    "Confluence": ["semantic-confluence-prod"],
    "E.ON MyGenius": ["questionator-mygenius-api-prod"],
    "E.ON Apps": [EnvironmentConfig.semanticAppIndex as "semantic-apps-dev" | "semantic-apps-prod"],
} as const;

export const featureFlagIndices = new Map(Object.entries(featureFlagIndicesData));

export const personalizedSearchIndiciesByCompany = {
    "E.DIS Netz GmbH": new Map(Object.entries(personalizedSearchData["E.DIS Netz GmbH"])),
    default: new Map()
} as const;

export const defaultSearchIndices = new Map(Object.entries(defaultSearchData));

export const allowedSuggestionsIndices = [
    EnvironmentConfig.semanticOfficeBuddyIndex,
    EnvironmentConfig.appIndex,
    "semantic-meeondata-azureblob-prod",
    ...EnvironmentConfig.semanticKbServiceNowIndex,
    "questionator-order-it-api-prod"
];